import { useCinematicsStore } from '@/cinematics/stores/CinematicsStore'
import { useBrandingLayerContext } from '@/cinematics/providers/BrandingLayerContext'
import { BrandSlot } from '@/types/branding'

/**
 * Single accessor for brand assets. Base assets (logo/icon/lottiePath)
 * always come from the cinematic ambiance, regardless of layer — team
 * branding doesn't replace them today. getSlotAsset is the one place that
 * consults the active BrandingLayer, so a slot only resolves when the team
 * layer is active and Design has wired an asset for it.
 */
export function useBrandAssets() {
  const { ambiance } = useCinematicsStore()
  const layer = useBrandingLayerContext()

  const logo = ambiance?.images?.logo || ''
  const icon = ambiance?.images?.icon || ''
  const logoLarge = ambiance?.images?.logo_large || ''
  const lottiePath = ambiance?.images?.lottiePath

  const getSlotAsset = (slot: BrandSlot): string | undefined =>
    layer?.kind === 'team' ? layer.theme.assets?.[slot] : undefined

  return { logo, icon, logoLarge, lottiePath, getSlotAsset }
}
